export default __webpack_public_path__ + "static/media/StiveChange.835df9ac.svg";